import {Button, Spinner, Typography} from "@material-tailwind/react";
import {useCallback, useEffect, useState} from "react";
import {getAgentProfile} from "../../../services/agent/agent_profile";
import {AgentRequestManagement} from "../agent_request/agent_request";
import {AgentProfileManagement} from "./AgentProfileManagement";

export function AgentProfileWorkspace({changeComponent}) {
  const [state, setState] = useState({status: "loading", data: null});

  const load = useCallback(async () => {
    setState({status: "loading", data: null});
    const response = await getAgentProfile();

    if (response?.status === 200) {
      setState({status: "profile", data: response.data});
      return;
    }
    if (response?.status === 404) {
      setState({status: "onboarding", data: null});
      return;
    }
    setState({status: "error", data: null});
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  if (state.status === "loading") {
    return (
      <div className="flex min-h-72 items-center justify-center gap-3 text-app-text-muted">
        <Spinner className="h-6 w-6"/>
        <Typography>در حال بررسی وضعیت پروفایل...</Typography>
      </div>
    );
  }

  if (state.status === "onboarding") {
    return <AgentRequestManagement changeComponent={changeComponent}/>;
  }

  if (state.status === "error") {
    return (
      <div className="mx-auto flex min-h-72 max-w-xl flex-col items-center justify-center gap-4 rounded-2xl border border-app-border bg-app-surface p-8 text-center">
        <Typography variant="h6" className="text-app-text">دریافت پروفایل انجام نشد</Typography>
        <Typography className="text-sm text-app-text-muted">اتصال خود را بررسی کنید و دوباره تلاش کنید.</Typography>
        <Button className="bg-app-primary text-app-on-primary" onClick={load}>تلاش دوباره</Button>
      </div>
    );
  }

  return <AgentProfileManagement initialData={state.data}/>;
}
